import { render } from "./FTConsumptionDetails.vue?vue&type=template&id=6fc80d20&scoped=true"
import script from "./FTConsumptionDetails.vue?vue&type=script&lang=js"
export * from "./FTConsumptionDetails.vue?vue&type=script&lang=js"

import "./FTConsumptionDetails.vue?vue&type=style&index=0&id=6fc80d20&scoped=true&lang=css"
import "./FTConsumptionDetails.vue?vue&type=style&index=1&id=6fc80d20&lang=css"
script.render = render
script.__scopeId = "data-v-6fc80d20"

export default script